import React, { useCallback, useState } from 'react';
import cx from 'classnames';
import { CDN_TYPE_SPORT, getCDNUrl } from 'utils';

import { ArchivedTournamentProvider } from '@atlas/core';
import { Flag, Icon } from '@atlas/ui';

import ResultsEventsList from 'components/Pages/Results/ResultsEvents/ResultsEventsList';

const ResultsTournamentItem = ({ forceIsExpanded, tournament }) => {
  const { id, name } = tournament;
  const [isExpanded, setIsExpanded] = useState(forceIsExpanded);

  const toggleExpanded = useCallback(() => {
    setIsExpanded(isExpanded => !isExpanded);
  }, [setIsExpanded]);

  const arrowClassName = cx({ down: !isExpanded, up: isExpanded });

  const iconArrowClassName = cx(`arrow-${arrowClassName}`);

  return (
    <ArchivedTournamentProvider key={id} tournament={tournament}>
      <div className="menu-item-container sport">
        <div className="menu-item-icon">
          <Flag
            alt={name}
            cdnHostname={getCDNUrl(CDN_TYPE_SPORT)}
            height={16}
            name={id}
            width={20}
          />
        </div>
        <div className="menu-item-text" onClick={toggleExpanded}>
          <h3 className="main-label">{name}</h3>
        </div>
        <div className="menu-item-icon-controls">
          <div className="font-icon-container">
            <Icon name={iconArrowClassName} onClick={toggleExpanded} />
          </div>
        </div>
      </div>
      {isExpanded && <ResultsEventsList showDates />}
    </ArchivedTournamentProvider>
  );
};

export default ResultsTournamentItem;
